import React from "react";
import styled from "styled-components";
import { theme } from "@ui/styles/theme";
import { Tooltipable } from "@ui/tooltips/tooltipable";
import { InfoIcon } from "./icons";

interface InfoBulleProps extends React.HTMLAttributes<HTMLDivElement> {
	text: string;
	customStyle?: { backgroundColor: string; textColor: string; backgroundColorIcon: string; textColorIcon: string };
	position?: "left" | "right" | "top" | "bottom";
}

export const InfoBulle: React.FC<InfoBulleProps> = ({
	text,
	customStyle = {
		backgroundColor: theme.colors.secondary,
		textColor: theme.colors.white,
		backgroundColorIcon: theme.colors.white,
		textColorIcon: theme.colors.secondary,
	},
	position = "bottom",
	...htmlProps
}) => {
	return (
		<Tooltipable text={text} customStyle={customStyle} position={position}>
			<Container backgroundColorIcon={customStyle.backgroundColorIcon} {...htmlProps}>
				<InfoIcon backgroundcolor={customStyle.backgroundColorIcon} textColor={customStyle.textColorIcon} />
			</Container>
		</Tooltipable>
	);
};

const Container = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== "backgroundColorIcon",
})<{ backgroundColorIcon: string }>`
	display: flex;
	align-items: center;
	background-color: ${({ backgroundColorIcon }) => backgroundColorIcon};
	width: 20px;
	height: 20px;
	border-radius: 50%;
`;
